import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useSiteContent } from "../context/SiteContentContext";
import { ServiceSlideshow } from "../components/ServiceSlideshow";
import { ProjectVideosSection } from "../components/VideoShowcase";

export default function ServicesPage() {
  const { services, programmes } = useSiteContent();
  return (
    <div data-testid="services-page">
      <section className="pt-32 md:pt-44 pb-12">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-14 text-center">
          <p className="font-mono uppercase text-xs tracking-[0.25em] text-[#EC4899]">Services & Programmes</p>
          <h1 className="font-display text-black text-5xl md:text-7xl lg:text-[100px] leading-[0.92] mt-6">
            What we do.<br />
            {/* <span className="italic text-[#EC4899]">Real people.</span> */}
          </h1>
          <p className="max-w-2xl mx-auto mt-8 text-lg text-black/70 leading-relaxed">
          From weekly workshops to fun family activities, we provide a wide range of services, events, and experiences for the whole family and our wider community.          </p>
        </div>
      </section>

      {/* SERVICES BENTO */}
      <section className="py-16 md:py-24" data-testid="services-grid">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-14">
          <div className="flex items-end justify-between flex-wrap gap-4 mb-12">
            <div>
              <p className="font-mono uppercase text-3xl md:text-4xl tracking-[0.25em] text-[#EC4899]">Our services</p>
              {/* <h2 className="font-display text-4xl md:text-5xl text-black mt-3 leading-tight">How we show up.</h2> */}
            </div>
          </div>
          <div className="grid md:grid-cols-2 gap-5">
            {services.map((s, i) => (
              <article key={`${s.title}-${i}`} data-testid={`service-card-${i}`} className={`group rounded-3xl overflow-hidden ${s.accent === "black" ? "bg-[#0A0A0A] text-white" : "bg-[#FDF2F8]"} hover:shadow-hover transition-all hover:-translate-y-1`}>
                <ServiceSlideshow images={s.images || [s.image]} alt={s.title} />
                <div className="p-8">
                  <div className="flex items-center justify-between">
                    <span className={`font-mono text-[11px] uppercase tracking-[0.25em] ${s.accent === "black" ? "text-[#EC4899]" : "text-[#EC4899]"}`}>Service 0{i + 1}</span>
                    <ArrowUpRight size={18} className={s.accent === "black" ? "text-white/50 group-hover:text-white" : "text-black/40 group-hover:text-black"} />
                  </div>
                  <h3 className={`font-display text-2xl md:text-3xl mt-3 leading-tight ${s.accent === "black" ? "text-white" : "text-black"}`}>{s.title}</h3>
                  <p className={`mt-3 leading-relaxed text-[15px] ${s.accent === "black" ? "text-white/75" : "text-black/70"}`}>{s.text}</p>
                  {Array.isArray(s.bullets) && s.bullets.length > 0 && (
                    <ul className={`mt-4 space-y-2 text-[15px] leading-relaxed ${s.accent === "black" ? "text-white/75" : "text-black/70"}`}>
                      {s.bullets.map((item) => (
                        <li key={item} className="flex gap-3">
                          <span className="mt-[0.55rem] h-1.5 w-1.5 shrink-0 rounded-full bg-[#EC4899]" aria-hidden />
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* PROGRAMMES */}
      {/* <section className="py-20 md:py-28 bg-[#FDF2F8]" data-testid="programmes-section">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-14 grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <p className="font-mono uppercase text-xs tracking-[0.25em] text-[#EC4899]">Our programmes</p>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-black mt-4 leading-[0.95]">{programmes.headline}</h2>
            <p className="mt-6 text-lg text-black/75 leading-relaxed">{programmes.body}</p>
            <Link to="/contact" data-testid="programmes-cta" className="mt-8 inline-flex items-center gap-2 px-7 py-4 rounded-full bg-[#EC4899] text-white font-medium hover:bg-[#DB2777] transition-all hover:-translate-y-[2px] shadow-pink">
              Enquire about a programme <ArrowUpRight size={18} />
            </Link>
          </div>
          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-5">
            {programmes.pillars.map((p, i) => (
              <div key={p.label} data-testid={`pillar-${i}`} className="rounded-3xl p-8 bg-white border border-black/6 hover:border-[#EC4899]/50 hover:-translate-y-1 transition-all">
                <Sparkles size={22} className="text-[#EC4899]" />
                <h3 className="font-display text-2xl text-black mt-4 leading-tight">{p.label}</h3>
                <p className="mt-3 text-sm text-black/70 leading-relaxed">{p.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      <ProjectVideosSection />

      {/* CTA */}
      <section className="px-6 md:px-10 lg:px-14 pb-24 pt-16">
        <div className="max-w-[1440px] mx-auto rounded-[40px] p-10 md:p-16 bg-[#0A0A0A] text-white grid lg:grid-cols-12 gap-8 items-center">
          <h2 className="lg:col-span-8 font-display text-4xl md:text-5xl lg:text-6xl leading-[0.95]">Ready to join a session? <span className="italic text-[#EC4899]">Come say hello.</span></h2>
          <div className="lg:col-span-4 flex flex-col gap-3">
            <Link to="/contact" data-testid="services-cta-contact" className="inline-flex items-center justify-between px-7 py-5 rounded-full bg-[#EC4899] text-white font-medium shadow-pink">Contact us <ArrowUpRight size={18} /></Link>
            <Link to="/what-we-do" data-testid="services-cta-wwd" className="inline-flex items-center justify-between px-7 py-5 rounded-full border border-white/25">See what we do <ArrowUpRight size={18} /></Link>
          </div>
        </div>
      </section>
    </div>
  );
}
